import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleApiError, getResponse } from "../Handler/ExceptionHandler";
import { toast } from "react-toastify";
import { baseUrl } from "../../utils/envAccess";

//#region Dashboard
export const activeUserCount = createAsyncThunk(
  "admin/activeUserCount",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.get(
        `${baseUrl}Admin/GetActiveUserCount`,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);
//#endregion Dashboard

//#region Preview Link

export const addPreviewLinkRecord = createAsyncThunk(
  "admin/addPreviewLinkRecord",
  async (obj, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const formData = new FormData();
    formData.append("title", obj.title);
    formData.append("description", obj.description);
    formData.append("link", obj.link);
    if (obj.primaryImage) {
      formData.append("primaryImage", obj.primaryImage);
    }
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "multipart/form-data",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Admin/AddPreviewLink`,
        formData,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (responseBack?.status) {
        toast.success(responseBack?.message);
      }
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const updatePreviewLinkRecord = createAsyncThunk(
  "admin/updatePreviewLinkRecord",
  async (obj, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const formData = new FormData();
    formData.append("id", obj.id);
    formData.append("title", obj.title);
    formData.append("description", obj.description);
    formData.append("link", obj.link);
    if (obj.primaryImage) {
      formData.append("primaryImage", obj.primaryImage);
    }
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "multipart/form-data",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Admin/UpdatePreviewLink`,
        formData,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (responseBack?.status) {
        toast.success(responseBack?.message);
      }
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const previewLinkList = createAsyncThunk(
  "admin/previewLinkList",
  async (
    { page, size, sortColumn, sortDirection, searchParam },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Admin/GetPreviewLink?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortDirection}&searchValue=${searchParam}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);
//#endregion Dashboard

//#region Company

export const addCompany = createAsyncThunk(
  "user/postCompany",
  async (company, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const formData = new FormData();
    formData.append("companyName", company.companyName);
    formData.append("profilePicture", company.profilePicture);
    formData.append("companyAddress", company.companyAddress);
    formData.append("companyContact", company.companyContact);
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "multipart/form-data",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Admin/AddCompany`,
        formData,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (responseBack?.status) {
        toast.success(responseBack?.message);
      } else {
        toast.error(responseBack?.message);
      }
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const companyListDropdown = createAsyncThunk(
  "user/companyListDropdown",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.get(
        `${baseUrl}Admin/GetCompanyList`,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const companyList = createAsyncThunk(
  "user/companyList",
  async (
    { page, size, sortColumn, sortOrder, searchParam },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Admin/GetCompany?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortOrder}&searchValue=${searchParam}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const updateRecord = createAsyncThunk(
  "user/updateRecord",
  async (company, { rejectWithValue, getState, dispatch }) => {
    const users = getState()?.authentication?.userAuth;
    const formData = new FormData();
    formData.append("Id", company.id);
    formData.append("companyName", company.companyName);
    formData.append("profilePicture", company.profilePicture);
    formData.append("companyAddress", company.companyAddress);
    formData.append("companyContact", company.companyContact);
    const config = {
      headers: {
        Authorization: `Bearer ${users?.token}`,
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const response = await axios.put(
        `${baseUrl}Admin/UpdateCompany`,
        formData,
        config,
      );
      const responseBack = getResponse(response, dispatch, users);
      if (responseBack.status) {
        toast.success(responseBack?.message);
      }
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, users);
    }
  },
);

//#endregion

//#region Department

export const addDepartment = createAsyncThunk(
  "user/addDepartment",
  async (department, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Admin/AddDepartment`,
        department,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      }
      console.log(responseBack);
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const departmentList = createAsyncThunk(
  "user/departmentList",
  async (
    { page, size, sortColumn, sortDirection, searchParam },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Admin/GetDepartment?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortDirection}&searchValue=${searchParam}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const updateDepartment = createAsyncThunk(
  "user/updateDepartment",
  async (department, { rejectWithValue, getState, dispatch }) => {
    const users = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        Authorization: `Bearer ${users?.token}`,
      },
    };

    try {
      const response = await axios.put(
        `${baseUrl}Admin/UpdateDepartment`,
        department,
        config,
      );
      const responseBack = getResponse(response, dispatch, users);
      if (responseBack.status) {
        toast.success(responseBack?.message);
      }
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, users);
    }
  },
);

export const departmentListDropdown = createAsyncThunk(
  "user/departmentListDropdown",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.get(
        `${baseUrl}Admin/GetDepartmentList`,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

//#endregion

//#region User
export const addUser = createAsyncThunk(
  "user/addUser",
  async (users, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const formData = new FormData();
    formData.append("firstName", users.firstName);
    formData.append("lastName", users.lastName);
    formData.append("userName", users.userName);
    formData.append("email", users.email);
    formData.append("primaryContact", users.phoneNumber);
    formData.append("password", users.password);
    formData.append("address", users.address);
    formData.append("gender", users.gender);
    formData.append("role", parseInt(users.role));
    formData.append("dob", users.dob);
    formData.append("employeeId", users.employeeId);
    formData.append("companyId", users.companyId);
    formData.append("departmentId", users.departmentId);
    formData.append("profilePicture", users.profilePicture);
    formData.append("cnicFrontScan", users.cnicFrontScan);
    formData.append("cnicBackScan", users.cnicBackScan);
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "multipart/form-data",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Admin/AddEmployee`,
        formData,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (responseBack?.status) {
        toast.success(responseBack?.message);
      }
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const updateUserPersonalDetail = createAsyncThunk(
  "user/updateUserPersonalDetail",
  async (users, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const formData = new FormData();
    formData.append("id", users.id);
    formData.append("companyId", users.companyId);
    formData.append("firstName", users.firstName);
    formData.append("lastName", users.lastName);
    formData.append("primaryContact", users.phoneNumber);
    formData.append("address", users.address);
    formData.append("gender", users.gender);
    formData.append("dob", users.dob);
    formData.append("profilePicture", users.profilePicture);
    formData.append("cnicFrontScan", users.cnicFrontScan);
    formData.append("cnicBackScan", users.cnicBackScan);
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "multipart/form-data",
      },
    };
    try {
      const response = await axios.put(
        `${baseUrl}Admin/UpdatePersonalDetail`,
        formData,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (responseBack?.status) {
        toast.success(responseBack?.message);
      }
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const usersList = createAsyncThunk(
  "user/usersList",
  async (
    { page, size, sortColumn, sortDirection, searchParam },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Admin/GetUserTable?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortDirection}&searchValue=${searchParam}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const userListDropdown = createAsyncThunk(
  "user/userListDropdown",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.get(`${baseUrl}Admin/GetUserList`, config);
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);
//#endregion

//#region GetLists
export const salaryHistory = createAsyncThunk(
  "user/salaryHistory",
  async (
    {
      page,
      size,
      sortColumn,
      sortDirection,
      searchParam,
      userId,
      startDate,
      endDate,
    },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Home/GetSalarySlipsDataTable?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortDirection}&searchValue=${searchParam}&userId=${userId}&startDate=${startDate}
        &endDate=${endDate}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const designationHistory = createAsyncThunk(
  "user/designationHistory",
  async (
    {
      page,
      size,
      sortColumn,
      sortDirection,
      searchParam,
      userId,
      startDate,
      endDate,
    },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Home/GetDesignationHistoryTable?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortDirection}&searchValue=${searchParam}&userId=${userId}&startDate=${startDate}
        &endDate=${endDate}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const designationHistoryList = createAsyncThunk(
  "user/designationHistoryList",
  async (
    { page, size, sortColumn, sortDirection, searchParam, startDate, endDate },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Home/GetDesignationHistoryListTable?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortDirection}&searchValue=${searchParam}&startDate=${startDate}
        &endDate=${endDate}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const workTimeHistory = createAsyncThunk(
  "user/workTimeHistory",
  async (
    {
      page,
      size,
      sortColumn,
      sortDirection,
      searchParam,
      userId,
      startDate,
      endDate,
    },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Home/GetWorkTimingTable?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortDirection}&searchValue=${searchParam}&userId=${userId}&startDate=${startDate}
        &endDate=${endDate}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const addPersonalDocument = createAsyncThunk(
  "user/addPersonalDocument",
  async (data, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const formData = new FormData();
    formData.append("documentType", data.documentType);
    formData.append("userId", data.userId);
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "multipart/form-data",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Admin/AddPersonalDocument`,
        formData,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (responseBack?.status) {
        toast.success(responseBack?.message);
      }
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const personalDocumentDataTable = createAsyncThunk(
  "user/personalDocumentDataTable",
  async (
    { page, size, sortColumn, sortDirection, searchParam, userId },
    { rejectWithValue, getState, dispatch },
  ) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Admin/PersonalDocumentDataTable?start=${page}&length=${size}&sortColumnName=${sortColumn}
        &sortDirection=${sortDirection}&searchValue=${searchParam}&userId=${userId}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);

export const downloadActivityReport = createAsyncThunk(
  "admin/downloadActivityReport",
  async ({ startDate, endDate } = {}, { rejectWithValue, getState }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        Accept: "*/*",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
      responseType: "blob",
      params: {
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
      },
    };

    try {
      const response = await axios.get(`${baseUrl}Admin/DownloadActivityReport`, config);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Download failed");
    }
  },
);

// Superseded by the real endpoints below (Admin/GetAllAppointments,
// Admin/GetAppointmentsByDoctor/{DoctorId}) - kept commented out as a
// rollback reference, not deleted. There is no Admin/SearchAppointments or
// Admin/CancelAppointment on the backend; AdminAppointmentRow.ManageUrl is
// the actual, confirmed cancellation mechanism (see its doc comment: "Use
// this to cancel a Booked appointment on the patient's behalf").
//
// export const searchAppointments = createAsyncThunk(
//   "admin/searchAppointments",
//   async (
//     { page, size, patientName, doctorName, startDate, endDate, status },
//     { rejectWithValue, getState, dispatch },
//   ) => {
//     const user = getState()?.authentication?.userAuth;
//     const config = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${user?.obj?.token}`,
//       },
//     };
//
//     try {
//       const response = await axios.post(
//         `${baseUrl}Admin/SearchAppointments?start=${page}&length=${size}` +
//           `&patientName=${encodeURIComponent(patientName || "")}` +
//           `&doctorName=${encodeURIComponent(doctorName || "")}` +
//           `&startDate=${startDate || ""}&endDate=${endDate || ""}` +
//           `&status=${status || ""}`,
//         null,
//         config,
//       );
//       const responseBack = getResponse(response, dispatch, user);
//       return responseBack;
//     } catch (error) {
//       handleApiError(error?.response?.data, dispatch, user);
//       return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
//     }
//   },
// );
//
// export const adminCancelAppointment = createAsyncThunk(
//   "admin/adminCancelAppointment",
//   async (
//     { appointmentId, reason, requestedBy },
//     { rejectWithValue, getState, dispatch },
//   ) => {
//     const user = getState()?.authentication?.userAuth;
//     const config = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${user?.obj?.token}`,
//       },
//     };
//
//     try {
//       const response = await axios.post(
//         `${baseUrl}Admin/CancelAppointment`,
//         { AppointmentId: appointmentId, Reason: reason || "", RequestedBy: requestedBy },
//         config,
//       );
//       const responseBack = getResponse(response, dispatch, user);
//       return responseBack;
//     } catch (error) {
//       handleApiError(error?.response?.data, dispatch, user);
//       return rejectWithValue(error?.response?.data);
//     }
//   },
// );

// POST Admin/GetAllAppointments - body is AdminAppointmentListRequest
// { startDate?, endDate?, doctorId?, patientId?, page, pageSize, sortDescending }.
// Every filter is optional. Response is PaginatedAdminAppointments:
// { data: AdminAppointmentRow[], currentPage, pageSize, totalRecords,
//   totalPages, hasPreviousPage, hasNextPage }. Each row already carries
// manageUrl - the real cancellation mechanism, no separate cancel call needed.
export const getAllAppointments = createAsyncThunk(
  "admin/getAllAppointments",
  async (request, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.post(`${baseUrl}Admin/GetAllAppointments`, request, config);
      return response?.data;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
      return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
    }
  },
);

// POST Admin/GetAppointmentsByDoctor/{doctorId} - same request/response shape
// as GetAllAppointments, pinned to one doctor via the route (doctorId in the
// body, if sent, is ignored server-side).
export const getAppointmentsByDoctor = createAsyncThunk(
  "admin/getAppointmentsByDoctor",
  async ({ doctorId, ...request }, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Admin/GetAppointmentsByDoctor/${doctorId}`,
        request,
        config,
      );
      return response?.data;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
      return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
    }
  },
);


export const getPatientCreditBalance = createAsyncThunk(
  "admin/getPatientCreditBalance",
  async (userRef, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.get(`${baseUrl}Admin/GetPatientCreditBalance/${userRef}`, config);
      return response?.data;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
      return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
    }
  },
);

// GET Admin/GetPatientCreditHistory/{userRef} - ledger rows, newest first. Returned raw.
export const getPatientCreditHistory = createAsyncThunk(
  "admin/getPatientCreditHistory",
  async (userRef, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.get(`${baseUrl}Admin/GetPatientCreditHistory/${userRef}`, config);
      return response?.data;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
      return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
    }
  },
);

// GET Admin/GetPatientPurchaseHistory/{userRef} - paginated paid plans. Silent on 404 since
// not every backend has this endpoint yet.
export const getPatientPurchaseHistory = createAsyncThunk(
  "admin/getPatientPurchaseHistory",
  async ({ userRef, page = 1 }, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
      params: { page, pageSize: 10 },
    };

    try {
      const response = await axios.get(`${baseUrl}Admin/GetPatientPurchaseHistory/${userRef}`, config);
      return response?.data?.data;
    } catch (error) {
      if (error?.response?.status !== 404) handleApiError(error?.response?.data, dispatch, user);
      return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
    }
  },
);


export const adjustPatientCredit = createAsyncThunk(
  "admin/adjustPatientCredit",
  async (request, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.post(`${baseUrl}Admin/AdjustPatientCredit`, request, config);
      return response?.data;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
      return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
    }
  },
);

// POST Admin/PatientQuickSignUp - signs a patient up on their behalf (same fields/validation
// as Auth/UserQuickSignUp). 200 with status:false means the email is already registered.
export const adminPatientQuickSignUp = createAsyncThunk(
  "admin/adminPatientQuickSignUp",
  async (request, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.post(`${baseUrl}Admin/PatientQuickSignUp`, request, config);
      if (response?.data?.status === false) {
        return rejectWithValue({ ...response.data, httpStatus: response.status });
      }
      return response?.data;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
      return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
    }
  },
);

// GET Admin/GetAllDoctorsAllTimeSlots/{userRef}?location= - providers with their Zoom
// initialBookingLink and followUpBookingLink; the caller picks which one to open.
export const getAdminDoctorsForPatient = createAsyncThunk(
  "admin/getAdminDoctorsForPatient",
  async ({ userRef, location }, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      params: location ? { location } : undefined,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.get(
        `${baseUrl}Admin/GetAllDoctorsAllTimeSlots/${encodeURIComponent(userRef)}`,
        config,
      );
      return response?.data;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
      return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
    }
  },
);

const planRequest = async (method, path, body, { rejectWithValue, getState, dispatch }) => {
  const user = getState()?.authentication?.userAuth;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user?.obj?.token}`,
    },
  };

  try {
    const response =
      method === "get"
        ? await axios.get(`${baseUrl}${path}`, config)
        : await axios.post(`${baseUrl}${path}`, body, config);
    if (response?.data?.success === false) {
      return rejectWithValue({ ...response.data, httpStatus: response.status });
    }
    return response?.data;
  } catch (error) {
    handleApiError(error?.response?.data, dispatch, user);
    return rejectWithValue({ ...error?.response?.data, httpStatus: error?.response?.status });
  }
};

export const getSubscriptionPlans = createAsyncThunk(
  "admin/getSubscriptionPlans",
  async (includeInactive = true, thunkApi) =>
    planRequest("get", `Admin/GetSubscriptionPlans?includeInactive=${includeInactive}`, null, thunkApi),
);

export const getCreditTypes = createAsyncThunk("admin/getCreditTypes", async (_, thunkApi) =>
  planRequest("get", "Admin/GetCreditTypes", null, thunkApi),
);

export const createSubscriptionPlan = createAsyncThunk("admin/createSubscriptionPlan", async (body, thunkApi) =>
  planRequest("post", "Admin/CreateSubscriptionPlan", body, thunkApi),
);

export const updateSubscriptionPlan = createAsyncThunk(
  "admin/updateSubscriptionPlan",
  async ({ subscriptionId, ...body }, thunkApi) =>
    planRequest("post", `Admin/UpdateSubscriptionPlan/${subscriptionId}`, body, thunkApi),
);

export const deactivateSubscriptionPlan = createAsyncThunk(
  "admin/deactivateSubscriptionPlan",
  async (subscriptionId, thunkApi) =>
    planRequest("post", `Admin/DeactivateSubscriptionPlan/${subscriptionId}`, null, thunkApi),
);

export const reactivateSubscriptionPlan = createAsyncThunk(
  "admin/reactivateSubscriptionPlan",
  async (subscriptionId, thunkApi) =>
    planRequest("post", `Admin/ReactivateSubscriptionPlan/${subscriptionId}`, null, thunkApi),
);

export const createSubscriptionCoupon = createAsyncThunk(
  "admin/createSubscriptionCoupon",
  async ({ subscriptionId, ...body }, thunkApi) =>
    planRequest("post", `Admin/CreateSubscriptionCoupon/${subscriptionId}`, body, thunkApi),
);

export const updateSubscriptionCoupon = createAsyncThunk(
  "admin/updateSubscriptionCoupon",
  async ({ couponId, ...body }, thunkApi) =>
    planRequest("post", `Admin/UpdateSubscriptionCoupon/${couponId}`, body, thunkApi),
);

export const deactivateSubscriptionCoupon = createAsyncThunk(
  "admin/deactivateSubscriptionCoupon",
  async (couponId, thunkApi) =>
    planRequest("post", `Admin/DeactivateSubscriptionCoupon/${couponId}`, null, thunkApi),
);

export const reactivateSubscriptionCoupon = createAsyncThunk(
  "admin/reactivateSubscriptionCoupon",
  async (couponId, thunkApi) =>
    planRequest("post", `Admin/ReactivateSubscriptionCoupon/${couponId}`, null, thunkApi),
);
//#endregion

const adminSlices = createSlice({
  name: "admin",
  initialState: {
    loading: false,
    appErr: null,
    appStatus: null,
    appStatusCode: null,
    serverErr: null,
    patientCreditBalance: [],
    creditBalanceLoading: false,
    creditHistory: [],
    creditHistoryLoading: false,
    creditAdjustmentLoading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(addCompany.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addCompany.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addCompany.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(companyList.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(companyList.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(companyList.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(companyListDropdown.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(companyListDropdown.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(companyListDropdown.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(userListDropdown.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(userListDropdown.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(userListDropdown.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(activeUserCount.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(activeUserCount.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(activeUserCount.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(previewLinkList.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(previewLinkList.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(previewLinkList.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(addPreviewLinkRecord.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addPreviewLinkRecord.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addPreviewLinkRecord.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(updatePreviewLinkRecord.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(updatePreviewLinkRecord.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(updatePreviewLinkRecord.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(departmentListDropdown.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(departmentListDropdown.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(departmentListDropdown.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(updateRecord.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(updateRecord.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(updateRecord.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(updateUserPersonalDetail.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(updateUserPersonalDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(updateUserPersonalDetail.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(addUser.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addUser.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addUser.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(addDepartment.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addDepartment.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addDepartment.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(departmentList.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(departmentList.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(departmentList.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(updateDepartment.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(updateDepartment.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(updateDepartment.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(usersList.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(usersList.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(usersList.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    //#region Lists

    builder.addCase(salaryHistory.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(salaryHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(salaryHistory.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(designationHistory.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(designationHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(designationHistory.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(designationHistoryList.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(designationHistoryList.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(designationHistoryList.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    //#endregion

    //#region Documents
    builder.addCase(addPersonalDocument.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addPersonalDocument.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addPersonalDocument.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    builder.addCase(personalDocumentDataTable.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(personalDocumentDataTable.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(personalDocumentDataTable.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    //#endregion

    //#region Reports
    builder.addCase(downloadActivityReport.pending, (state) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(downloadActivityReport.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(downloadActivityReport.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message || "Failed to download report.";
    });
    //#endregion

    //#region Manage Appointments
    builder.addCase(getAllAppointments.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(getAllAppointments.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(getAllAppointments.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(getAppointmentsByDoctor.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(getAppointmentsByDoctor.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(getAppointmentsByDoctor.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    //#endregion

    //#region Patient Credit Adjustment
    builder.addCase(getPatientCreditBalance.pending, (state) => {
      state.creditBalanceLoading = true;
    });
    builder.addCase(getPatientCreditBalance.fulfilled, (state, action) => {
      state.creditBalanceLoading = false;
      state.patientCreditBalance = Array.isArray(action.payload) ? action.payload : [];
    });
    builder.addCase(getPatientCreditBalance.rejected, (state, action) => {
      state.creditBalanceLoading = false;
      state.appErr = action?.payload?.message;
    });

    builder.addCase(getPatientCreditHistory.pending, (state) => {
      state.creditHistoryLoading = true;
    });
    builder.addCase(getPatientCreditHistory.fulfilled, (state, action) => {
      state.creditHistoryLoading = false;
      state.creditHistory = Array.isArray(action.payload) ? action.payload : [];
    });
    builder.addCase(getPatientCreditHistory.rejected, (state, action) => {
      state.creditHistoryLoading = false;
      state.appErr = action?.payload?.message;
    });

    builder.addCase(adjustPatientCredit.pending, (state) => {
      state.creditAdjustmentLoading = true;
    });
    builder.addCase(adjustPatientCredit.fulfilled, (state) => {
      state.creditAdjustmentLoading = false;
    });
    builder.addCase(adjustPatientCredit.rejected, (state, action) => {
      state.creditAdjustmentLoading = false;
      state.appErr = action?.payload?.message;
    });
    //#endregion
  },
});

export default adminSlices.reducer;
